import SearchForm from "./SearchForm";
import SearchFormItem from "./SearchFormItem";
import { useSearchFormInstance } from "./SearchFormHook";
SearchForm.Item = SearchFormItem;
SearchForm.useSearchFormInstance = useSearchFormInstance;
export default SearchForm;
